import _extends from "@babel/runtime/helpers/extends";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/utils/withWarningMessage.js",
    _this = this;

import React, { forwardRef, useEffect } from 'react';
import getComponentName from '../../helpers/getComponentName';
/**
 *
 * @param {React.Component} Component The component to be deprecated
 * @param {Object} metadata
 * @param {String} metadata.message Deprecation message
 * @return {React.Component}
 */

var withWarningMessage = function withWarningMessage(Component) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var componentDisplayName = getComponentName(Component);
  var message = metadata.message;

  var WithWarningMessage = function WithWarningMessage(props, ref) {
    useEffect(function () {
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        console.warn(message);
      }
    }, []);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      ref: ref,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 12
      }
    }));
  };

  WithWarningMessage.displayName = componentDisplayName;
  return /*#__PURE__*/forwardRef(WithWarningMessage);
};

export default withWarningMessage;